import moment from 'moment'

export interface Holiday {
  start: string
  end: string
}

/**
 * Fungsi untuk memfilter tanggal,
 * mengembalikan false untuk Sabtu, Minggu, dan hari libur,
 * true untuk hari kerja biasa.
 */
export function filterDate(date: Date, holidaysData?: Holiday[]): boolean {
  // disable if the day is saturday or sunday
  if (date.getDay() === 0) return false

  // disable if the day is publicHoliday
  if (
    holidaysData?.some(holiday => {
      const holidayStart = moment(holiday.start, 'YYYY-MM-DDTHH:mm:ssZ')
      const holidayEnd = moment(holiday.end, 'YYYY-MM-DDTHH:mm:ssZ')
      return moment(date).isBetween(holidayStart, holidayEnd, 'day', '[]')
    })
  ) {
    return false
  }

  return true
}
